// extracted by css-extract-rspack-plugin
export default {"seven":"seven--eXqP3kxcNL4mW2dt"};